"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7725],{

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ LandingWhiteSec; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kj": function() { return /* binding */ LandingGreySecWrap; },
/* harmony export */   "zq": function() { return /* binding */ LandingGreySec; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "shared-styled-components__Flex",
  componentId: "sc-1i94ptm-0"
})(["display:flex;align-items:center;"]);
var LandingGreySec = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "shared-styled-components__LandingGreySec",
  componentId: "sc-1i94ptm-1"
})(["background:#f5f5f5;padding:", ";margin-top:-120px;margin-bottom:", ";@media only screen and (max-width:768px){padding:", ";margin-top:", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.padding || "16px";
}, function (props) {
  return props.marginTop || "0px";
});
var LandingGreySecWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "shared-styled-components__LandingGreySecWrap",
  componentId: "sc-1i94ptm-2"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingWhiteSec = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "shared-styled-components__LandingWhiteSec",
  componentId: "sc-1i94ptm-3"
})(["width:1200px;margin:0 auto;background:#fff;padding:", ";@media only screen and (max-width:768px){width:100%;padding:16px;}"], function (props) {
  return props.padding;
});

/***/ }),

/***/ 7725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LandingMoneyTransfer_LandingMoneyTransfer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingMoneyTransfer/LandingMoneyTransfer.style.ts

var LandingMoneyTransfer_style_LandingMoneyTransfer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingMoneyTransferstyle__LandingMoneyTransfer",
  componentId: "sc-1179lv4-0"
})(["display:flex;align-items:center;background:#fff;padding:16px 16px 16px 42px;border-radius:16px;position:relative;& .brownArr{width:100px;height:50px;position:absolute;right:100px;top:185px;z-index:1;}& .blueArr{width:100px;height:50px;position:absolute;top:126px;right:186px;z-index:1;}& .moneyTrans1{width:84px;height:105px;position:absolute;right:227px;top:77px;transform:scale(0.8);}& .moneyTrans2{width:48px;height:80px;position:absolute;right:91px;top:115px;transform:scale(0.8);}& .moneyTrans3{width:48px;height:59px;position:absolute;right:195px;bottom:28px;transform:scale(0.8);}& .moneyTrans4{width:33px;height:51px;position:absolute;right:112px;bottom:31px;transform:scale(0.8);}"]);
var LandingMoneyTransferTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingMoneyTransferstyle__LandingMoneyTransferTitle",
  componentId: "sc-1179lv4-1"
})(["font-family:\"Raleway\";font-style:normal;font-weight:500;font-size:40px;line-height:54px;color:#000000;margin-bottom:24px;"]);
var LandingMoneyTransferImgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingMoneyTransferstyle__LandingMoneyTransferImgWrap",
  componentId: "sc-1179lv4-2"
})(["margin-left:84px;display:flex;"]);
var GreyBoxSmall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingMoneyTransferstyle__GreyBoxSmall",
  componentId: "sc-1179lv4-3"
})(["width:158px;height:133px;background:#fafafa;border-radius:20px;flex-shrink:0;&:first-child{margin-bottom:8px;}"]);
var GreyBoxBig = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingMoneyTransferstyle__GreyBoxBig",
  componentId: "sc-1179lv4-4"
})(["background:#fafafa;border-radius:20px;width:172px;height:273px;margin-left:12px;flex-shrink:0;"]);
var LandingMoneyTransferList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingMoneyTransferstyle__LandingMoneyTransferList",
  componentId: "sc-1179lv4-5"
})(["font-weight:400;font-size:18px;line-height:32px;padding-left:18px;gap:66px;margin-bottom:24px;display:flex;& li{position:relative;}& li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:8px;background:#000000;border-radius:14px;}"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
// EXTERNAL MODULE: ../../node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(4682);
// EXTERNAL MODULE: ../../node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(5480);
var ScrollTrigger_default = /*#__PURE__*/__webpack_require__.n(ScrollTrigger);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useMoneyTransferAnim/index.tsx



var useMoneyTransferAnim = function useMoneyTransferAnim() {
  var ANIMATION_TYPE = "ease-in-out";
  gsap/* default.registerPlugin */.ZP.registerPlugin((ScrollTrigger_default()));
  (0,react.useEffect)(function () {
    var timeId = setTimeout(function () {
      var rootContainerElement = document.getElementById("root_container");
      var moneyTransElement = document.getElementById("moneyTransferMobile_ref");
      var brownArrElement = document.getElementById("brownArrMobile_ref");
      var blueArrElement = document.getElementById("blueArrMobile_ref");
      var moneyTrans1Element = document.getElementById("moneyTrans1Mobile_ref");
      var moneyTrans2Element = document.getElementById("moneyTrans2Mobile_ref");
      var moneyTrans3Element = document.getElementById("moneyTrans3Mobile_ref");
      var moneyTrans4Element = document.getElementById("moneyTrans4Mobile_ref");
      gsap/* default.to */.ZP.to(brownArrElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: moneyTransElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        x: -43,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(blueArrElement, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: moneyTransElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        x: 42,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(moneyTrans1Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: moneyTransElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        scale: 1,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(moneyTrans2Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: moneyTransElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        scale: 1,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(moneyTrans3Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: moneyTransElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        scale: 1,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
      gsap/* default.to */.ZP.to(moneyTrans4Element, {
        scrollTrigger: {
          scroller: rootContainerElement,
          trigger: moneyTransElement,
          start: "top+=100px center",
          toggleActions: "restart none none reverse"
        },
        scale: 1,
        ease: ANIMATION_TYPE,
        duration: 0.9
      });
    }, 300);
    return function () {
      return clearTimeout(timeId);
    };
  }, []);
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingMoneyTransfer/LandingMoneyTransfer.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var LandingMoneyTransfer = function LandingMoneyTransfer(_ref) {
  var title = _ref.title,
      list = _ref.list,
      imgs = _ref.imgs;
  useMoneyTransferAnim();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingGreySec */.zq, {
    padding: "3rem 0 5rem 0",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingGreySecWrap */.kj, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingMoneyTransfer_style_LandingMoneyTransfer, {
        id: "moneyTransferMobile_ref",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingMoneyTransferTitle, {
            children: title
          }), list && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingMoneyTransferList, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: list[0]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: list[1]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: "Coming soon"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingMoneyTransferImgWrap, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GreyBoxSmall, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(GreyBoxSmall, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(GreyBoxBig, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
          id: "brownArrMobile_ref",
          className: "brownArr"
        }, imgs === null || imgs === void 0 ? void 0 : imgs[0])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
          id: "blueArrMobile_ref",
          className: "blueArr"
        }, imgs === null || imgs === void 0 ? void 0 : imgs[1])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
          id: "moneyTrans1Mobile_ref",
          className: "moneyTrans1"
        }, imgs === null || imgs === void 0 ? void 0 : imgs[2])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
          id: "moneyTrans2Mobile_ref",
          className: "moneyTrans2"
        }, imgs === null || imgs === void 0 ? void 0 : imgs[3])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
          id: "moneyTrans3Mobile_ref",
          className: "moneyTrans3"
        }, imgs === null || imgs === void 0 ? void 0 : imgs[4])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
          id: "moneyTrans4Mobile_ref",
          className: "moneyTrans4"
        }, imgs === null || imgs === void 0 ? void 0 : imgs[5]))]
      })
    })
  });
};

/* harmony default export */ var LandingMoneyTransfer_LandingMoneyTransfer = (LandingMoneyTransfer);

/***/ })

}]);